import { render, staticRenderFns } from "./ImageIibraryModal.vue?vue&type=template&id=5c2a02d8&scoped=true"
import script from "./ImageIibraryModal.vue?vue&type=script&lang=ts"
export * from "./ImageIibraryModal.vue?vue&type=script&lang=ts"
import style0 from "./ImageIibraryModal.vue?vue&type=style&index=0&id=5c2a02d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2a02d8",
  null
  
)

export default component.exports